// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Sud.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Sud.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/MagnoSans-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/MagnoSans-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Retail-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Sud";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* MagnoSans Black (woff2 + woff) */
@font-face {
  font-family: "MagnoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

/* Retail Regular (OTF) */
@font-face {
  font-family: "Retail-Regular";
  src: local("Retail-Regular"),
       url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

body, Popup {
    margin: 0;
    font-family: "Retail-Regular", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.magnoHeader {
    font-family: "MagnoSans", magno-sans-variable, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: 0.75px;
}

.sudHeader {
    font-family: "Sud";
    font-size: 15px;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.75px;
    color: rgb(29, 29, 29);
}

.retailRegular {
    font-family: "Retail-Regular";
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.75px;
    color: rgb(29, 29, 29);
}

.filterCollapseButton {
    background: white;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB;6DACkD;EAClD,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB;6DAC8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B;iEACgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;IACI,SAAS;IACT,gLAAgL;IAChL,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;EACE;aACW;AACb;;AAEA;IACI,yDAAyD;IACzD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["@font-face {\n  font-family: \"Sud\";\n  src: url('./assets/fonts/Sud.woff2') format('woff2'),\n       url('./assets/fonts/Sud.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* MagnoSans Black (woff2 + woff) */\n@font-face {\n  font-family: \"MagnoSans\";\n  src: url('./assets/fonts/MagnoSans-Black.woff2') format('woff2'),\n       url('./assets/fonts/MagnoSans-Black.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* Retail Regular (OTF) */\n@font-face {\n  font-family: \"Retail-Regular\";\n  src: local(\"Retail-Regular\"),\n       url('./assets/fonts/Retail-Regular.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\nbody, Popup {\n    margin: 0;\n    font-family: \"Retail-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.magnoHeader {\n    font-family: \"MagnoSans\", magno-sans-variable, sans-serif;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 900;\n    letter-spacing: 0.75px;\n}\n\n.sudHeader {\n    font-family: \"Sud\";\n    font-size: 15px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.75px;\n    color: rgb(29, 29, 29);\n}\n\n.retailRegular {\n    font-family: \"Retail-Regular\";\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500;\n    letter-spacing: 0.75px;\n    color: rgb(29, 29, 29);\n}\n\n.filterCollapseButton {\n    background: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
